import { Alert, Button, Form, Input, Typography } from "antd";
import React, { useState } from "react";
import { md5 } from "./md5";

const PASSWORD_HASH = "dcda45bfdc9ad81ce431eb0f283ae5d2";

export const PasswordGate: React.FC<{ children: React.ReactNode; storageKey: string }> = ({
  children,
  storageKey,
}) => {
  const [unlocked, setUnlocked] = useState(() => localStorage.getItem(storageKey) === "1");
  const [error, setError] = useState(false);

  if (unlocked) {
    return <>{children}</>;
  }

  const handleFinish = (values: { password: string }) => {
    if (md5(values.password) === PASSWORD_HASH) {
      localStorage.setItem(storageKey, "1");
      setUnlocked(true);
      setError(false);
    } else {
      setError(true);
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", paddingTop: 96 }}>
      <div style={{ width: 320 }}>
        <Typography.Title level={4} style={{ marginBottom: 24, textAlign: "center" }}>
          Passwort erforderlich
        </Typography.Title>
        <Form layout="vertical" onFinish={handleFinish} onValuesChange={() => setError(false)}>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "Bitte Passwort eingeben" }]}
          >
            <Input.Password autoFocus placeholder="Passwort" />
          </Form.Item>
          {error && (
            <Alert
              type="error"
              message="Falsches Passwort"
              showIcon
              style={{ marginBottom: 16 }}
            />
          )}
          <Form.Item style={{ marginBottom: 0 }}>
            <Button type="primary" htmlType="submit" block>
              Entsperren
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
